import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../../components/Layout/layout";
import ApiKeyManager from "../../../components/Superadmin/apiKey";
import { HeaderType } from "../../../components/Layout/header";
import ProtectedRoute from "../../../../Auth/components/ProtectedRoute";

const ApiKeyManagerContainer = () => (
  <ProtectedRoute>
    <main>
    <Helmet title="Sms Api Keys" />
    <Layout headerType={HeaderType.superadmin}>
      <ApiKeyManager />
    </Layout>
    </main>
  </ProtectedRoute>
);

export default ApiKeyManagerContainer;
